import React, {Fragment} from 'react';
import ShippingEditor from './shippingEditor';
import connect from "react-redux/es/connect/connect";
import Box from "../layout/Box";
import moment from "moment";

class PersonalPickupEditor extends React.Component {
    render() {
        if (!(this.props.till && this.props.till.pos && this.props.till.pos.location && this.props.till.pos.location.id)) {
            return <Box header="Hiba" theme="danger">
                Nem vagy átvételi pontba bejelentkezve!
            </Box>;
        }
        return (
            <ShippingEditor
                editorContext="PersonalPickup"
                {...this.props}
                listFilter={[
                    {
                        field: "status",
                        value: 30
                    },
                    {
                        field: "state",
                        value: 1
                    }
                ]}
                pos={this.props.till.pos}
            />
        );
    }
}

export class FailedPersonalPickup extends React.Component {
    render() {
        if (!(this.props.till && this.props.till.pos && this.props.till.pos.location && this.props.till.pos.location.id)) {
            return <Box header="Hiba" theme="danger">
                Nem vagy átvételi pontba bejelentkezve!
            </Box>;
        }
        return (
            <ShippingEditor
                editorContext="FailedPersonalPickup"
                {...this.props}
                failedActions={true}
                pos={this.props.till.pos}
            />
        );
    }
}

export const FailedPersonalPickupEditor = connect((state) => {
    return {
        till: state.app.till
    };
}, {})(FailedPersonalPickup);

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(PersonalPickupEditor);

